import { useTheme } from "../../../context/ThemeContext";

export default function CobranzaDashboard() {
  const { isDarkMode } = useTheme();

  const themeClasses = {
    bg: isDarkMode ? "bg-dark-bg" : "bg-gray-50",
    cardBg: isDarkMode ? "bg-dark-surface" : "bg-white",
    cardBorder: isDarkMode ? "border-dark-border" : "border-gray-200",
    text: isDarkMode ? "text-white" : "text-gray-900",
    textSecondary: isDarkMode ? "text-gray-400" : "text-gray-600",
  };

  const mockStats = [
    { label: "Total Cobrado", value: "$1,245,890", change: "+12.5%", positive: true, icon: "ri-money-dollar-circle-line" },
    { label: "Pendiente por Cobrar", value: "$345,200", change: "-8.2%", positive: true, icon: "ri-time-line" },
    { label: "Clientes al Día", value: "89", change: "+5", positive: true, icon: "ri-user-follow-line" },
    { label: "Clientes con Adeudo", value: "23", change: "-3", positive: true, icon: "ri-user-unfollow-line" },
  ];

  const recentPayments = [
    { company: "Transportes del Norte", amount: "$15,400", date: "Hoy, 10:30 AM", status: "completed" },
    { company: "Logística Express", amount: "$8,200", date: "Hoy, 09:15 AM", status: "completed" },
    { company: "Fletes Rápidos SA", amount: "$22,100", date: "Ayer", status: "completed" },
    { company: "Carga Segura MX", amount: "$5,800", date: "Ayer", status: "pending" },
    { company: "Distribuidora Central", amount: "$12,350", date: "27 Feb", status: "completed" },
  ];

  const overdueAccounts = [
    { company: "Mudanzas Express", amount: "$4,500", daysOverdue: 15, devices: 12 },
    { company: "Transporte Veloz", amount: "$8,200", daysOverdue: 30, devices: 25 },
    { company: "Carga Pesada MX", amount: "$2,100", daysOverdue: 7, devices: 8 },
  ];

  return (
    <div className={`w-full h-full p-6 overflow-auto ${themeClasses.bg}`}>
      <div className="mb-6">
        <h1 className={`text-2xl font-bold ${themeClasses.text}`}>
          Dashboard de Cobranza
        </h1>
        <p className={`text-sm ${themeClasses.textSecondary} mt-1`}>
          Resumen de pagos y cuentas por cobrar
        </p>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {mockStats.map((stat, index) => (
          <div
            key={index}
            className={`${themeClasses.cardBg} border ${themeClasses.cardBorder} rounded-xl p-4`}
          >
            <div className="flex items-center justify-between mb-2">
              <span className={`text-sm ${themeClasses.textSecondary}`}>{stat.label}</span>
              <i className={`${stat.icon} text-xl text-primary-500`} />
            </div>
            <div className={`text-2xl font-bold ${themeClasses.text}`}>{stat.value}</div>
            <div className={`text-sm mt-1 ${stat.positive ? "text-primary-500" : "text-red-500"}`}>
              {stat.change} vs mes anterior
            </div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Recent Payments */}
        <div className={`${themeClasses.cardBg} border ${themeClasses.cardBorder} rounded-xl p-4`}>
          <h2 className={`text-lg font-semibold ${themeClasses.text} mb-4`}>
            Pagos Recientes
          </h2>
          <div className="space-y-3">
            {recentPayments.map((payment, index) => (
              <div
                key={index}
                className={`flex items-center justify-between p-3 rounded-lg ${isDarkMode ? "bg-dark-card" : "bg-gray-50"}`}
              >
                <div>
                  <p className={`font-medium ${themeClasses.text}`}>{payment.company}</p>
                  <p className={`text-sm ${themeClasses.textSecondary}`}>{payment.date}</p>
                </div>
                <div className="text-right">
                  <p className={`font-semibold ${themeClasses.text}`}>{payment.amount}</p>
                  <span className={`text-xs px-2 py-1 rounded-full ${
                    payment.status === "completed" 
                      ? "bg-primary-500/20 text-primary-500" 
                      : "bg-yellow-500/20 text-yellow-500"
                  }`}>
                    {payment.status === "completed" ? "Completado" : "Pendiente"}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Overdue Accounts */}
        <div className={`${themeClasses.cardBg} border ${themeClasses.cardBorder} rounded-xl p-4`}>
          <h2 className={`text-lg font-semibold ${themeClasses.text} mb-4`}>
            Cuentas Vencidas
          </h2>
          <div className="space-y-3">
            {overdueAccounts.map((account, index) => (
              <div
                key={index}
                className={`flex items-center justify-between p-3 rounded-lg ${isDarkMode ? "bg-dark-card" : "bg-gray-50"}`}
              >
                <div>
                  <p className={`font-medium ${themeClasses.text}`}>{account.company}</p>
                  <p className={`text-sm ${themeClasses.textSecondary}`}>
                    {account.devices} dispositivos
                  </p>
                </div>
                <div className="text-right">
                  <p className={`font-semibold text-red-500`}>{account.amount}</p>
                  <span className="text-xs text-red-400">
                    {account.daysOverdue} días vencido
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
